import React from "react";
import {Col} from "react-bootstrap";
import InlineForm from "../FromGroup/InlineForm";
import Component from "../../../components/AscComponent";
import CommonTable from "../Table/CommonTable";
import "./ProperNounElements.css";
import SetDataWithSpeechBubble from "./SetDataWithSpeechBubble";


/**
 * 固有名詞入力アイテム
 * state.hintsが必要
 */
export class EditProperNounHints extends Component {
    render() {
        let displayData = `${this.props.langText.Body.TokenCnt} : (${this.props.state.tokenCount}/${this.props.state.totalTokensLimitCnt-this.props.state.totalTokens})`;
        return (
            <>
                <InlineForm
                    key = "propernoun_hints"
                    controlId = "propernoun_hints"
                    label = {this.props.langText.Body.Noun}
                    type = "text"
                    value = {this.props.state.hints}
                    onChange = {e => {
                        this.props.onTextChange_Limit(
                            e, "hints",this.props.charaLimit.ProperNoun_ProperNounHints);
                        this.props.getTokenCount(e.target.value);
                    }}
                    validationstate = {this.props.state.properNoun_hints ? null : "error"} />
                <Col>
                    <SetDataWithSpeechBubble
                        className = {this.props.state.token_flag ? "token-count" : "token-count-error"}
                        displayData = {displayData}
                        speechBubbleData = {this.props.langText.Message.ProperNoun_TokenCnt_Explanation}
                        infoIconDisplayFlag = {true}
                        infoIconType = {null}
                        infoIconClassName = "modal-info-icon"
                        infoIconColor = "silver"
                        infoIconSize = "lg"/>
                </Col>
            </>
        );
    }
}

/**
 * 固有名詞表示アイテム
 * state.hintsが必要
 */
export class ViewProperNounHints extends Component {
    render() {
        return (
            <InlineForm
                key = "propernoun_hints"
                controlId = "propernoun_hints"
                label = {this.props.langText.Body.Noun}
                type = "text"
                value = {this.props.state.hints}
                readOnly/>
        );
    }
}

/**
 * 削除項目ビューアイテム
 * state.id, state.hintsが必要
 */
export class ViewProperNounList extends Component {
    render(){
        return(
            <InlineForm
                key = "propernoun_detail"
                controlId = "propernoun_detail">
                <CommonTable
                    className = "none-overflow"
                    showPagination = {true}
                    defaultPageSize = {10}
                    columns = {[{
                        Header :this.props.langText.Body.NounId,
                        accessor: "id",
                    },
                    {
                        Header :this.props.langText.Body.Noun,
                        accessor: "hints",
                    }]}
                    data = {this.props.state.selectedData}
                />
            </InlineForm>
        );
    }
}